import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "작성일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["작성일", "평가일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({key: 'created_at', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'created_at', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });

    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "회사명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "피평가자",
        key: "body.inputA_5",
      },
      {
        name: "평가일",
        key: "body.inputA_6",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 사업장명
        case 1: return func.getContent(value).inputA_5 // 피평가자
        case 2: return func.getContent(value).inputA_6 // 평가일
        case 3: return func.getContent(value).stdInfo.writer_name; // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
